import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import StructuredData from '@/components/feature/StructuredData';
import { articles, categories } from '@/mocks/articles';

function getArticleImage(id: number): string {
  if (id === 1) return 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20livestream%20setup%20with%20neon%20ring%20light%20falling%20over%2C%20shattered%20makeup%20products%20on%20a%20dark%20floor%2C%20dim%20moody%20lighting%20with%20pink%20and%20cyan%20accents%2C%20cinematic%20composition%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20moody%20atmosphere%2C%20simple%20dark%20background&width=1200&height=600&seq=article-detail-1&orientation=landscape';
  if (id === 2) return 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20paparazzi%20camera%20flash%20effect%2C%20sleek%20black%20car%20pulling%20up%2C%20dramatic%20noir%20lighting%20with%20neon%20city%20reflections%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20with%20deep%20contrast%20and%20moody%20atmosphere%2C%20dark%20urban%20background&width=1200&height=600&seq=article-detail-2&orientation=landscape';
  if (id === 3) return 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20lighting%2C%20two%20silhouettes%20confronting%20each%20other%20on%20stage%2C%20cameras%20and%20crew%20in%20background%20blurred%2C%20intense%20atmosphere%20with%20spotlight%20beams%20cutting%20through%20haze%2C%20cinematic%20documentary%20style%2C%20dark%20studio%20background&width=1200&height=600&seq=article-detail-3&orientation=landscape';
  if (id === 4) return 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20glamorous%20editorial%20beauty%20portrait%20on%20one%20side%20and%20casual%20natural%20candid%20on%20the%20other%2C%20dramatic%20lighting%20contrast%2C%20fashion%20magazine%20style%20meets%20street%20photography%2C%20moody%20atmospheric%20tones%2C%20dark%20simple%20background%20with%20spotlight%20effect&width=1200&height=600&seq=article-detail-4&orientation=landscape';
  if (id === 5) return 'https://readdy.ai/api/search-image?query=Corporate%20office%20building%20at%20night%20with%20lights%20flickering%20dramatically%2C%20stock%20market%20charts%20showing%20sharp%20decline%20on%20dark%20screens%2C%20emergency%20documents%20scattered%20on%20desk%2C%20noir%20thriller%20atmosphere%20with%20cyan%20and%20red%20accent%20lighting%2C%20cinematic%20composition%2C%20dark%20corporate%20environment&width=1200&height=600&seq=article-detail-5&orientation=landscape';
  if (id === 6) return 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20a%20dark%20reflective%20surface%20with%20broken%20heart%20neon%20sign%20reflection%2C%20shattered%20glass%20effect%2C%20messy%20breakup%20atmosphere%20with%20scattered%20polaroid%20photos%2C%20moody%20pink%20and%20cyan%20lighting%2C%20editorial%20still%20life%20photography%2C%20dark%20background&width=1200&height=600&seq=article-detail-6&orientation=landscape';
  if (id === 7) return 'https://readdy.ai/api/search-image?query=Dark%20control%20room%20with%20multiple%20monitors%20showing%20voting%20data%20and%20graphs%2C%20dramatic%20spotlight%20on%20a%20single%20desk%20with%20scattered%20papers%2C%20mysterious%20surveillance%20atmosphere%2C%20cinematic%20thriller%20lighting%20with%20red%20accent%2C%20dark%20technical%20environment&width=1200&height=600&seq=article-detail-7&orientation=landscape';
  if (id === 8) return 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20sheet%20music%20and%20audio%20waveform%20comparison%20on%20dual%20monitors%2C%20dramatic%20split%20lighting%20showing%20original%20vs%20copy%2C%20vinyl%20records%20scattered%20on%20dark%20desk%2C%20moody%20atmosphere%20with%20cyan%20and%20amber%20accent%20lighting%2C%20editorial%20music%20documentary%20style&width=1200&height=600&seq=article-detail-8&orientation=landscape';
  if (id === 9) return 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20scattered%20on%20a%20laboratory%20testing%20table%20with%20microscope%20and%20chemical%20analysis%20equipment%2C%20dramatic%20lighting%20with%20test%20tube%20glow%2C%20investigation%20atmosphere%2C%20editorial%20product%20photography%20with%20moody%20shadows%2C%20dark%20scientific%20background&width=1200&height=600&seq=article-detail-9&orientation=landscape';
  return 'https://readdy.ai/api/search-image?query=Dark%20moody%20news%20photography%20scene%20with%20dramatic%20lighting%2C%20abstract%20composition%20with%20pink%20and%20cyan%20neon%20accents%2C%20editorial%20atmosphere%2C%20clean%20dark%20background%20with%20subtle%20texture&width=1200&height=600&seq=article-detail-fallback&orientation=landscape';
}

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const article = articles.find((a) => a.id === Number(id));
  const category = article ? categories.find((c) => c.slug === article.category) : null;
  const relatedArticles = article
    ? articles.filter((a) => a.category === article.category && a.id !== article.id).slice(0, 3)
    : [];

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-20 text-center">
          <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-4">
            <i className="ri-file-unknow-line text-2xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl font-heading font-bold text-foreground-50 mb-2">文章不存在</h1>
          <p className="text-foreground-400 mb-6">你查找的文章不存在或已被删除</p>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-foreground-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line"></i>
            返回首页
          </button>
        </main>
        <Footer />
      </div>
    );
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.911baoliao.com/' },
      category ? { '@type': 'ListItem', position: 2, name: category.name, item: `https://www.911baoliao.com/category/${category.slug}` } : null,
      { '@type': 'ListItem', position: category ? 3 : 2, name: article.title, item: `https://www.911baoliao.com/article/${article.id}` },
    ].filter(Boolean),
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    datePublished: article.date,
    author: {
      '@type': 'Organization',
      name: '911爆料网',
    },
    publisher: {
      '@type': 'Organization',
      name: '911爆料网',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://www.911baoliao.com/article/${article.id}`,
    },
  };

  return (
    <>
      <StructuredData data={breadcrumbSchema} />
      <StructuredData data={articleSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article className="pt-20 pb-10">
            <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  ...(category ? [{ label: category.name, href: `/category/${category.slug}` }] : []),
                  { label: article.title },
                ]}
              />

              {category && (
                <a
                  href={`/category/${category.slug}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/category/${category.slug}`); }}
                  className="inline-block px-3 py-1 rounded-full bg-primary-100/20 text-primary-400 text-xs font-medium mb-4 hover:bg-primary-100/30 transition-colors whitespace-nowrap"
                >
                  {category.name}
                </a>
              )}

              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-50 mb-4 leading-tight">
                {article.title}
              </h1>

              <div className="flex items-center gap-4 text-sm text-foreground-400 mb-8">
                <span className="whitespace-nowrap">
                  <i className="ri-calendar-line mr-1"></i>
                  {article.date}
                </span>
                <span className="whitespace-nowrap">
                  <i className="ri-eye-line mr-1"></i>
                  {article.views.toLocaleString()} 阅读
                </span>
                <span className="whitespace-nowrap">
                  <i className="ri-chat-3-line mr-1"></i>
                  {article.comments.toLocaleString()} 评论
                </span>
              </div>
            </div>

            <div className="w-full max-w-4xl mx-auto px-4 md:px-6 mb-10">
              <div className="relative aspect-[2/1] rounded-2xl overflow-hidden mb-10">
                <img
                  src={getArticleImage(article.id)}
                  alt={article.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div
                className="prose prose-lg max-w-none text-foreground-300 leading-relaxed article-content"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />
            </div>
          </article>

          {relatedArticles.length > 0 && (
            <section className="py-10 md:py-14 bg-background-100">
              <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-8">
                  相关推荐
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {relatedArticles.map((ra, index) => (
                    <article key={ra.id} className="group bg-background-200 border border-background-300 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-300 hover:border-background-400">
                      <a
                        href={`/article/${ra.id}`}
                        onClick={(e) => { e.preventDefault(); navigate(`/article/${ra.id}`); }}
                        className="block cursor-pointer"
                      >
                        <div className="relative aspect-[16/10] overflow-hidden">
                          <img
                            src={getArticleImage(ra.id)}
                            alt={ra.title}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            loading={index < 3 ? 'eager' : 'lazy'}
                          />
                        </div>
                        <div className="p-4 md:p-5">
                          <h3 className="text-base md:text-lg font-heading font-bold text-foreground-50 mb-2 line-clamp-2 leading-snug group-hover:text-primary-400 transition-colors">
                            {ra.title}
                          </h3>
                          <div className="flex items-center justify-between text-xs text-foreground-400">
                            <span className="whitespace-nowrap">{ra.date}</span>
                            <span className="whitespace-nowrap">{ra.views.toLocaleString()} 阅读</span>
                          </div>
                        </div>
                      </a>
                    </article>
                  ))}
                </div>
              </div>
            </section>
          )}
        </main>
        <Footer />
      </div>
    </>
  );
}